import { Box } from '@chakra-ui/react'
import { useRefUpdated } from 'ui/hooks/useRefUpdated'
import { useEffect, useRef } from 'react'
import { type Option, type SveaOrder } from 'ecosystem'
import { type SveaScoApi } from './types'

export interface NexiCheckoutProps {
  sveaOrder?: Option<SveaOrder>
  onReady?: (sveaCheckoutApi: SveaScoApi) => void
}

/** @see https://checkoutapi.svea.com/docs/#/javascript-api */
export const SveaCheckout = ({ sveaOrder, onReady }: NexiCheckoutProps) => {
  const handleIsReadyRef = useRefUpdated(onReady)

  const containerRef = useRef<HTMLDivElement>(null)

  // Since a custom script needs to be executed we must add the snippet via contextual fragment
  useEffect(() => {
    if (containerRef.current && sveaOrder?.Gui.Snippet) {
      const fragment = document.createRange().createContextualFragment(sveaOrder?.Gui.Snippet)
      containerRef.current.replaceChildren(fragment)
    }
  }, [sveaOrder?.Gui.Snippet])

  useEffect(() => {
    const handler = () => {
      handleIsReadyRef.current?.(window.scoApi)
    }

    document.addEventListener('checkoutReady', handler)

    return () => document.removeEventListener('checkoutReady', handler)
  }, [handleIsReadyRef])

  if (!sveaOrder?.Gui.Snippet) {
    return null
  }

  return (
    <Box width="100%">
      <div ref={containerRef} />
    </Box>
  )
}
